export * from './IconFileImage';
